//General
import React from 'react';
//Styles
import { Modal } from 'react-bootstrap';
import { TextField, MenuItem } from '@mui/material';
import { Formik, Form } from 'formik';
//Validations & context
import { useValidations } from '../../data/ValidationContext';
import { useWarehouse } from '../../data/warehouse/WarehouseContext';

function WarehouseAddModal({ show, handleClose }) {
  const { addWarehouse } = useWarehouse();
  const { vs_warehouse } = useValidations();

  const initialValues = { name: '', location: '', status: 'Aktif' };

  //HTML
  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Depo Ekle</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          validationSchema={vs_warehouse}
          onSubmit={(values, { resetForm }) => {
            addWarehouse(values);
            resetForm();
            handleClose();
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur }) => (
            <Form className="d-flex flex-column gap-3">
              <TextField
                name="name"
                label="Depo Adı"
                fullWidth
                size="small"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
              />
              <TextField
                name="location"
                label="Lokasyon"
                fullWidth
                size="small"
                value={values.location}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.location && Boolean(errors.location)}
                helperText={touched.location && errors.location}
              />


              <div className="d-flex justify-end gap-2 mt-3">
                <button type="button" className="btn btn-secondary" onClick={handleClose}>İptal</button>
                <button type="submit" className="btn btn-primary">Kaydet</button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

export default WarehouseAddModal;
